import { FC, useState } from "react";
import { useAvatarLoader, useStatus } from "@/hooks";
import { UserAvatar } from "@/components/user-avatar";
import { AvatarProps } from "@/components/avatar-load-manager/types";

export const AvatarLoadManager: FC<AvatarProps> = ({
  name,
  surname,
  size,
  sourceUrl = "",
  directSourceUrl,
  className,
  statusUrl,
  userId,
  ...rest
}) => {
  const [source, setSource] = useState<string>("");
  const { status } = useStatus(statusUrl, userId);
  const url = directSourceUrl ? "" : sourceUrl;

  useAvatarLoader(url, setSource);

  return (
    <UserAvatar
      className={className}
      size={size}
      name={name}
      surname={surname}
      source={directSourceUrl || source}
      status={statusUrl && userId ? status : undefined}
      {...rest}
    />
  );
};
